import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DIAGNOSTIC_STEP_PERMISSION_KEY, DIAGNOSTIC_STEP_VIDEO_VALUE } from "@/constants/diagnostics";
import { setDiagnosticsError, setDiagnosticsStep } from "@/store/features/diagnostics/slice";
import { ErrorTypes } from "@/store/features/diagnostics/types";
import { useAppDispatch } from "@/store/hooks";
import { Button } from "@/ui";
import DiagnosticsSection from "../DiagnosticsSection";

const Permissions = () => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useAppDispatch();

  const onClickCheckPermissions = async () => {
    try {
      setIsLoading(true);
      await navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(async (mediaStream) => {
        mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
      });

      setTimeout(() => navigator.mediaDevices.dispatchEvent(new Event('devicechange')), 500);
      dispatch(setDiagnosticsStep(DIAGNOSTIC_STEP_VIDEO_VALUE));
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setDiagnosticsError({ type: ErrorTypes.permissions, error }));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DiagnosticsSection id={DIAGNOSTIC_STEP_PERMISSION_KEY}>
      <div className="section-wrapper">
        <div className="section-content">
          <h2>{t('check_permissions')}</h2>
          <p>{t('permissions_description_1')}</p>
          <p>
            <b>{t('permissions_description_2')}</b>
          </p>
          <Button onClick={onClickCheckPermissions} disabled={isLoading}>
            {t('request_permissions')}
          </Button>
        </div>
        <div className="section-image">
          <img src={`/images/permission-${i18n.language}.webp`} alt="Permissions" />
        </div>
      </div>
    </DiagnosticsSection>
  );
};

export default Permissions;